































































































import {
  computed,
  defineComponent,
  reactive,
  Ref,
  ref,
  watch,
} from '@vue/composition-api';
import { useFormat } from 'vivat';
import { useMutation, useQuery, useResult } from '@vue/apollo-composable';
import PrettyCheck from 'pretty-checkbox-vue/check';

import waitingOrderOption from '@/table/delivery/waitingDelivery';
import useDeliveryAreaCode from '@/useDeliveryAreaCode';
import useAuth from '@/useAuth';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonChip from '@/components/CommonChip.vue';
import CommonDeliveryStatusSelect from '@/components/Delivery/CommonDeliveryStatusSelect.vue';
import CommonModalWithReasonSelector from '@/components/DeliveryNote/CommonModalWithReasonSelector.vue';

import getDeliveries from '@/gql/delivery/getDeliveries.gql';
import deleteDelivery from '@/gql/delivery/deleteDelivery.gql';
import countDelivery from '@/gql/delivery/countDelivery.gql';
import batchUpdateDeliveryStatus from '@/gql/delivery/batchUpdateDeliveryStatus.gql';

const WaitingOrder = defineComponent({
  setup() {
    const { me } = useAuth();
    const { translateDistanceType, distanceTypeToChipClass } = useDeliveryAreaCode();

    const filter = reactive({
      status: '',
      text: '',
      orderDate: {
        from: undefined,
        to: undefined,
      },
    });
    function clickDateHandler(date: any) {
      if (filter.orderDate.from === useFormat.date(date).computerShortDate()) {
        filter.orderDate = {
          from: undefined,
          to: undefined,
        };
      } else {
        filter.orderDate = {
          from: useFormat.date(date).computerShortDate(),
          to: useFormat.date(date).computerShortDate(),
        };
      }
    }
    const ordersVariable = computed(() => {
      const vars: {[key: string]: any} = {
        searchCustomerName: undefined,
        filterByStatus: 'PENDING_ORDER_CONFIRMATION',
        filterOrderDateBetween: undefined,
      };
      if (filter.text) {
        vars.searchCustomerName = `%${filter.text}%`;
      }
      if (filter.orderDate.from) {
        vars.filterOrderDateBetween = filter.orderDate;
      }
      return vars;
    });
    const getOrdersResult = (data: any) => data.deliveries;

    // Use with select box
    const selectedItemId: Ref<number[]> = ref([]);
    function selectItem(id: number | string) {
      const hitIndex = selectedItemId.value.indexOf(parseInt(id as string, 10));
      if (selectedItemId.value.indexOf(parseInt(id as string, 10)) > -1) selectedItemId.value.splice(hitIndex, 1);
      else selectedItemId.value.push(parseInt(id as string, 10));
    }

    // Not accept reason
    const notAcceptReasons = reactive([
      { label: 'พื้นที่ไม่เพียงพอ', active: false },
      { label: 'รถไม่เพียงพอ', active: false },
      { label: 'รถเสีย', active: false },
      { label: 'ศูนย์กระจายสินค้า ปิดทำการ', active: false },
      { label: 'สินค้าผิดคุณภาพ', active: false },
      { label: '', active: false },
    ]);

    // ==============================================
    // ===== Use to delete Delivery from system =====
    // ==============================================
    const refetchQueriesList = [
      'getDeliveries', 'countDelivery',
    ];
    const deleteDeliveryModal = ref(null);
    const deleteDeliveryMutation = useMutation(deleteDelivery, {
      refetchQueries: refetchQueriesList,
    });
    function deleteDeliveryAction(deliveryId: number) {
      deleteDeliveryMutation.mutate({
        id: deliveryId,
      });
    }

    // not accept mutation
    // TODO: Implement not accept reason
    // const updateDeliveries = ref({
    //   id: -1,
    //   status: 'PENDING',
    //   notAcceptReason: '',
    // });
    const notAcceptReason = ref('');
    const notAcceptDeliveryModal = ref(null);
    const confirmAcceptDeliveryModal = ref(null);
    // const updateDeliveryStatusMutation = useMutation(updateDeliveryStatus, () => ({
    //   variables: {
    //     id: updateDeliveries.value.id,
    //     input: {
    //       status: updateDeliveries.value.status,
    //     },
    //     // notAcceptReason: updateDeliveries.value.notAcceptReason,
    //   },
    // }));
    const batchStatus = ref('ACCEPT_SHIPMENT_BY_SHIPPING_PROVIDER');
    const batchUpdateDeliveryStatusMutation = useMutation(batchUpdateDeliveryStatus, () => ({
      variables: {
        ids: selectedItemId.value,
        status: batchStatus.value,
        failureReason: notAcceptReason.value ? notAcceptReason.value : undefined,
      },
      refetchQueries: refetchQueriesList,
    }));
    const batchUpdateDeliveriesStatusAction = (status: string) => {
      batchStatus.value = status;
      batchUpdateDeliveryStatusMutation.mutate();
    };
    function confirmNotAccept(val: { reason: string; index: number }) {
      const { reason } = val;
      notAcceptReason.value = reason;
      batchUpdateDeliveriesStatusAction('CANCEL');
      (notAcceptDeliveryModal.value as any).close();
    }
    batchUpdateDeliveryStatusMutation.onDone(() => {
      selectedItemId.value = [];
    });

    // count delivery to display on top panel
    const totalPendingOrder = ref(0);
    const { result: getCountDeliveryResult, loading: countDeliveryLoading } = useQuery(countDelivery, () => ({
      filterOrderDateBetween: filter.orderDate.from ? filter.orderDate : undefined,
    }), () => ({
      fetchPolicy: 'cache-and-network',
    }));
    const countDeliveryResult = useResult(getCountDeliveryResult, [
      { status: 'PENDING_ORDER_CONFIRMATION', count: 0 },
    ], (data) => data.countDelivery);
    watch(() => countDeliveryResult.value, (newVal, oldVal) => {
      if (!countDeliveryLoading.value && newVal !== oldVal) {
        totalPendingOrder.value = countDeliveryResult.value.find((countObj: any) => countObj.status === 'PENDING_ORDER_CONFIRMATION')?.count || 0;
      }
    });

    return {
      me,
      translateDistanceType,
      distanceTypeToChipClass,

      filter,
      clickDateHandler,
      waitingOrderOption,
      getDeliveries,
      ordersVariable,
      getOrdersResult,

      selectItem,
      selectedItemId,

      deleteDeliveryModal,
      deleteDeliveryMutation,
      deleteDeliveryAction,

      totalPendingOrder,

      // use with not accept shipment
      notAcceptReasons,
      notAcceptDeliveryModal,
      confirmNotAccept,
      // use to confirm accept
      // confirmAccept,
      confirmAcceptDeliveryModal,

      batchUpdateDeliveriesStatusAction,
    };
  },
  components: {
    PrettyCheck,
    CommonModalWithPreset,
    CommonDeliveryStatusSelect,
    CommonChip,
    CommonModalWithReasonSelector,
  },
});

export default WaitingOrder;
